'use strict'

import {ModelBase} from './base'
import {plateEmpty_frame, plate96_frame} from './plate_frame'
import {Well} from './Well'

import format from 'string-format'
import api from '../api'
import Queue from './Queue'


/**
 * Класс планшеты подробный с лунками,
 * для списка планшет пока нет класса
 */
class Plate extends ModelBase {

	static empty_plate = new Plate(
		{
			empty: true,
			name: '<NONE>',
			projects: [],

			// в пустой планшете нет лунок
			plate_frame: plateEmpty_frame,

			well_list: [],
			probe_list: [],
			points: [],

			sample_list: [],

			extra: false,
			failed: false,
			ready: false,

			notes: "",
		}, null)

	constructor(data, rootState) {
		super(data)

		// TODO: костыль формата планшеты
		// если в data был plate_frame (empty), то не перезаписываем
		if (!this.plate_frame) {
			this.plate_frame = plate96_frame
		}

		console.debug("Plate.constructor()")

		const me = this
		const queue = new Queue(function (task, callback) {
			task(function () {

				if (task.callback) {
					task.callback()
				}

				console.debug(task, ' done')
				callback()
			})
		})

		this._rootState = rootState

		const wells = Object.assign({}, ...(this.well_list).map(
			(w) => ({[w.well_num]: new Well(me, w, rootState)})
		))
		this.wells = wells

		// если data.probe_list пустой, то обращения к state не будет ни разу
		const probes = Object.assign({}, ...(data.probe_list).map(
			(probe_id) => ({[probe_id]: rootState.lists.probes[probe_id]})
		))
		this.probes = probes

		let samples = {}
		for (let well_num in wells) {
			const well = this.wells[well_num]
			if (well.sample != null) {
				const sample_id = well.sample.id
				if (!(sample_id in samples)) {
					samples[sample_id] = rootState.sample.samples[sample_id]
				}
			}
		}
		this.samples = samples

		// если планшета пустая (заглушка), то заглушки лунки не надо создавать,
		// иначе будут ошибки, или нужно слишком много условий в конструкторе Well
		if (data.plate_frame != plateEmpty_frame) {
			// вставим пропущенные объекты заглушки пустых лунок,
			// чтобы не проверять во многих других местах в коде
			this.empty_well = new Well(this, {
				empty: true,
				sample: 'no'
			}, rootState, null, queue)

			for (let row_i = 0; row_i < this.plate_frame.rows.length; row_i++)
				for (let col_i = 0; col_i < this.plate_frame.cols.length; col_i++) {
					const well_num = row_i * this.plate_frame.cols.length + col_i
					if (!(well_num in this.wells)) {
						this.wells[well_num] = this.empty_well
					}
				}
		}

		let k = 5
	}

	update(data) {
		if ('well_list' in data) {

			for (let w_i = 0; w_i < data.well_list.length; w_i++) {
				const well_data = data.well_list[w_i]
				this.wells[well_data.well_num] =
					new Well(this, well_data, this._rootState)
			}
		}
	}

	get_well(row_i, col_i) {
		const well_num = this.plate_frame.cols.length * row_i + col_i
		return this.wells[well_num]
	}

	get_coords(well_num) {
		const row = Math.floor(well_num / this.plate_frame.cols.length)
		const col = well_num - row * this.plate_frame.cols.length
		return {row, col}
	}
}

export {Plate}